import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionReveal } from './SectionReveal';
export function Guarantee() {
  return <section className="w-full bg-base" data-id="element-109" data-mp="1o33s8bhenif4">
      <div className="mx-auto max-w-2xl px-5 py-16 md:py-20" data-id="element-110" data-mp="223epbw9b5t8q">
        <SectionReveal data-id="element-111" data-mp="222n1x8pv71tj">
          <div className="rounded-2xl border border-alt bg-alt/40 p-8 text-center shadow-sm" data-id="element-112" data-mp="22124nbc614rz">
            <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-greenlive/15" data-id="element-113" data-mp="1x2il1hl1o52s">
              <ShieldCheckIcon className="h-9 w-9 text-greenlive" strokeWidth={2} data-id="element-114" data-mp="14fnymf4o2vmo" />
            </span>
            <h2 className="mt-5 text-2xl font-black text-ink sm:text-3xl" data-id="element-115" data-mp="1j5c3fqc24cf5">
              🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>
            <p className="mt-4 text-base font-semibold text-ink" data-id="element-116" data-mp="qo9icg2598jb">
              Descargás el pack. Lo usás para el Encuadre de tu cartera.
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-117" data-mp="lodecgtg5h3r">
              Si en 7 días no es lo que esperabas — devolución del 100% del
              importe abonado, sin formularios, sin justificaciones, sin drama.
            </p>
            <p className="mt-4 text-[15px] font-semibold leading-relaxed text-ink" data-id="element-118" data-mp="ypb7ninnqbvq">
              La tasa de devoluciones es menor al 1%. Porque una vez que lo
              abrís, no lo devolvés.
            </p>
          </div>
        </SectionReveal>
      </div>
    </section>;
}